__turbopack_context__.v({
  "login_button": "landing-login-controls-module-scss-module__pcL8uG__login_button",
  "login_label": "landing-login-controls-module-scss-module__pcL8uG__login_label",
});
